import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Message } from 'react-frontier';
import PromoterForm from '../components/PromoterForm';

import '../style/site.scss';

var PublicFormPage = ()=>{
	var { promoter_id } = useParams<{ promoter_id: string }>();
	var pid = parseInt(promoter_id);

	useEffect(()=>{
		document.title = 'Formulario de aplicación - Arema CRM';
	}, []);

	if(!pid || isNaN(pid)){
		return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
			<Message type='error' header='Enlace inválido' style={{ maxWidth: 500 }}>
				El enlace al formulario no es válido. Por favor solicita un nuevo enlace.
			</Message>
		</div>
	}

	return <div style={{ minHeight: '100vh', backgroundColor: '#f5f5f5', padding: '40px 16px' }}>
		<PromoterForm prospect_id={pid} mode='public' style={{ marginBottom: 40 }} />
	</div>
}

export default PublicFormPage;
